import { render } from 'preact';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PortalRecentQueryDetailApp } from '../components/detail/PortalRecentQueryDetailApp.jsx';
import { enableElectricMapDebugFromUrl } from '../lib/portal-electric-debug.js';
import { readEmbeddedPortalDetailShell, markDetailShellReady } from '../lib/portal-detail-shell.js';

enableElectricMapDebugFromUrl();
import 'mapbox-gl/dist/mapbox-gl.css';
import '../styles/portal-recent-queries.css';
import '../styles/portal-compare.css';
import '../styles/portal-recent-query-detail.css';
import '../styles/pp-loaders.css';
import '../styles/listing-html-rich.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const root = document.getElementById('pp-portal-recent-query-detail-root');
const embeddedShell = readEmbeddedPortalDetailShell();

if (root) {
  const snapshotId = Number(root.dataset.snapshotId || 0);
  const listingId = String(root.dataset.listingId || '').trim() || null;
  const handoffJobId =
    String(root.dataset.handoffJobId || '').trim()
    || new URLSearchParams(window.location.search).get('job_id')
    || null;
  render(
    <QueryClientProvider client={queryClient}>
      <PortalRecentQueryDetailApp
        snapshotId={snapshotId}
        listingId={listingId}
        handoffJobId={handoffJobId}
        initialShell={embeddedShell}
      />
    </QueryClientProvider>,
    root,
  );
}
